import React, { FC } from 'react';
import { Box } from '../Box';
import { Avatar } from '../Avatar';
import { Value } from '../Value';
import { Icon } from '../Icon';
import { Tooltip } from '../Tooltip';
import { IDescriptionProps } from './models';
import styled from './Description.module.scss';

export const Description: FC<IDescriptionProps> = (props) => {
  const { label, type, value, avatar, tooltip, extraContent, className, tooltipMaxWith } = props;

  return (
    <Box className={className} gap={8} alignItems="center">
      {avatar && <Avatar {...avatar} />}
      <Box column gap={tooltip ? 8 : 4}>
        <Box gap={4} alignItems="center">
          <span className={styled.label}>{label}</span>
          {extraContent && extraContent}
          {tooltip && (
            <Tooltip content={tooltip} maxWidth={tooltipMaxWith}>
              <Icon name="circleOutlineQuestion" size="sm" className={styled.tooltipIcon} />
            </Tooltip>
          )}
        </Box>
        <Value value={value} semanticType={type} className={styled.value} />
      </Box>
    </Box>
  );
};
